import { BaseType } from '../base/base-type';
import { TaxWithholdingOverrideTypeIdEnum } from './tax-withholding-override-type-id.enum';

export class TaxWithholdingOverrideType extends BaseType {
  public declare id: TaxWithholdingOverrideTypeIdEnum;
}
